// prefer default export if available
const preferDefault = m => m && m.default || m;
exports.components = {
  "component---src-deck-mdx": () => import("./../../../../../src/deck.mdx" /* webpackChunkName: "component---src-deck-mdx" */)
};